<template>
  <div id="companyUser" class="dashboard-editor-container">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <span class="fontStyle1">
          {{ $t('company.Companyname') }}：{{ basicinfo.companyName }}
        </span>
        <span class="fontStyle2" />
        <span class="fontStyle1">
          {{ $t('company.Companyaddress') }}：{{ basicinfo.companyAddr }}
        </span>
        <span class="fontStyle2" />
        <span class="fontStyle1">
          {{ $t('company.Companywebsite') }}：{{ basicinfo.companyUrl }}
        </span>
      </div>
    </el-row>
    <el-row id="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 列表 -->
        <div style="position: relative;padding:10px 20px 20px;">
          <div id="filter" style="margin-top:20px;">
            <div style="display: fixed;">
              <el-input v-model="tableObj.userLoginName" :placeholder="$t('company.Account')" clearable class="input-with-select deviceNameTable" @keyup.enter.native="changeSearch(tableObj.userLoginName)">
                <el-button slot="append" icon="el-icon-search" @click="changeSearch(tableObj.userLoginName)" />
              </el-input>
              <el-button type="primary" icon="el-icon-plus" style="float: right;margin-bottom: 10px;" @click="add" />
            </div>
          </div>
          <el-table :data="tableData" border style="padding-left: 5px;">
            <el-table-column prop="userRealName" :label="$t('company.Name')" />
            <el-table-column prop="userLoginName" :label="$t('company.Account')" />
            <el-table-column prop="roleName" :label="$t('company.Role')" />
            <el-table-column prop="userPhone" :label="$t('company.Mobile')" />
            <el-table-column prop="userEmail" :label="$t('company.Email')" />
            <!-- <el-table-column prop="action" :label="$t('yhubReport.Operating')" align="center" :render-header="renderHeader"> -->
            <el-table-column prop="action" :label="$t('yhubReport.Operating')" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <el-button type="primary" icon="el-icon-edit" size="mini" @click="edit(scope.row)" />
                  <!-- <el-button v-if="scope.row.children" type="primary" icon="el-icon-plus" size="mini" @click="add" /> -->
                  <el-button type="primary" icon="el-icon-delete " size="mini" @click="deleteOne(scope.row)" />
                  <!-- <el-button v-if="isShowEditPasswordBtn" type="primary" icon="el-icon-lock " size="mini" @click="editPassword(scope.row)" /> -->
                  <el-button type="primary" icon="el-icon-lock " size="mini" @click="editPassword(scope.row)" />
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow"
                background
                current-page.sync="listQuery.pageInfo.page"
                :page-sizes="listQuery.pageInfo.pageList"
                :page-size="listQuery.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQuery.pageInfo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop">
      <el-form ref="dataForm" :rules="addUserRules" :model="userPopObj" label-position="right" label-width="180px" style="width: 80%;max-width: 700px;margin-left: 50px;">
        <el-form-item :label="$t('company.Companyname')" prop="companyName">
          <el-input v-model="userPopObj.companyName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Account')">
          <el-input v-if="isAdd" v-model="userPopObj.userLoginName" @input="change($event)" />
          <el-input v-else v-model="userPopObj.userLoginName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item v-if="isAdd" :label="$t('company.Password')">
          <el-input v-model="userPopObj.userPassword" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Name')">
          <el-input v-model="userPopObj.userRealName" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Email')">
          <el-input v-model="userPopObj.userEmail" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Mobile')">
          <el-input v-model="userPopObj.userPhone" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Role')">
          <!-- <el-select v-model="userPopObj.roleName" class="filter-item" filterable clearable @change="roleSelect">
            <el-option v-for="(item,index) in roleOptions" :key="index" :label="item.value" :value="item.key" />
          </el-select> -->
          <el-select v-model="userPopObj.roleIds" multiple :placeholder="$t('company.Role')">
            <el-option v-for="(item,index) in roleOptions" :key="index" :label="item.value" :value="item.key" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('company.drmModule')">
          <el-cascader v-if="isShowDrm" v-model="userPopObj.drmModule" :options="drmModuleOptions" :props="props" @change="moduleSelect" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmPop('dataForm')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowEditPasswordPop">
      <el-form ref="editPassword" :rules="editPassRules" :model="editPasswordObj" label-position="right" label-width="180px" style="width: 80%;max-width: 600px;margin-left: 50px;">
        <el-form-item :label="$t('company.Name')" prop="userRealName">
          <el-input v-model="editPasswordObj.userRealName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.Account')" prop="userLoginName">
          <el-input v-model="editPasswordObj.userLoginName" :disabled="true" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.NewPassword')" prop="newPassward1">
          <el-input v-model="editPasswordObj.newPassward1" :placeholder="$t('company.enterNewPass')" @input="change($event)" />
        </el-form-item>
        <el-form-item :label="$t('company.NewPassword')" prop="newPassward2">
          <el-input v-model="editPasswordObj.newPassward2" :placeholder="$t('company.enterNewPassAgain')" @input="change($event)" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowEditPasswordPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="editPasswordConfirmPop('editPassword')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pageList, saveUserInfo, updateById, deleteById2, getRoles, insertUserAndRoles, resetPassword } from '@/api/company'
import { pagination } from '@/utils/init_table' // 分页
var Base64 = require('js-base64').Base64

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      basicinfo: {
        companyName: this.$route.query.companyName,
        companyAddr: this.$route.query.companyAddr,
        companyUrl: this.$route.query.companyUrl
      },
      tableObj: {},
      tableData: [],
      isShowPop: false,
      addUserRules: {},
      userPopObj: {
        roleIds: [],
        drmModule: []
      },
      isAdd: false,
      roleOptions: [],
      isShowEditPasswordBtn: false, // 是否展示修改密码按钮
      isShowEditPasswordPop: false,
      editPasswordObj: {
        userRealName: '',
        userLoginName: '',
        newPassward1: '',
        newPassward2: ''
      },
      props: { multiple: true },
      isShowDrm: true
    }
  },
  computed: {
     editPassRules() {
      return {
        newPassward1: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }],
        newPassward2: [{ required: true, message: this.$t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    },
    drmModuleOptions() {
      return [
        {
          value: 1,
          label: this.$t('company.DesktopMagt'), // '桌面管理',
          children: [
            {
              value: 'yhub',
              label: this.$t('AllDevices.BatteryMonitor') // '电池监控器'
            },
            {
              value: 'lithium',
              label: this.$t('AllDevices.LithiumBattery') // '锂电池'
            },
            {
              value: 'charger',
              label: this.$t('AllDevices.charger') // '充电器'
            },
            {
              value: 'kisae',
              label: 'KISAE'
            },
            {
              value: 'Energy',
              label: 'Energy Management'
            },
            {
              value: 'lease',
              label: this.$t('company.LeaseMagt') // '租赁管理'
            }
          ]
        },
        /* {
          value: 2,
          label: this.$t('company.BasicModule'), // '基础模块',
          children: [
            {
              value: 'deviceMsg',
              label: this.$t('company.DeviceMsg') // '设备消息'
            },
            {
              value: 'accountMagt',
              label: this.$t('company.AccountMagt') // '账号管理'
            },
            {
              value: 'deviceDis',
              label: this.$t('company.deviceDis') // '设备分布'
            }
          ]
        } */
      ]
    }

  },
  mounted() {
    this.queryList()
    this.initRoles()
  },
  created() {
    // this.queryList()
  },
  methods: {
    queryList() { // 基本信息
      var param = {
        'companyId': Base64.decode(this.$route.query.id).split('+')[0],
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize,
        'userLoginName': this.tableObj.userLoginName,
        'userRealName': ''
      }
      pageList(param).then(res => {
        this.listQuery.pageInfo.total = res.resultModel.total // 分页
        this.tableData = res.resultModel.list // 列表数据
        this.tableData.forEach(v => {
          var rolesArr = []
          if (v.roleInfos) {
            if (v.roleInfos.indexOf(',') > -1) { rolesArr = v.roleInfos.split(',') } else { rolesArr.push(v.roleInfos) }
            v.roleName = ''
            rolesArr.forEach((m, mi) => {
              if (mi != (rolesArr.length - 1)) { v.roleName += m.split('##')[1] + ' , ' } else { v.roleName += m.split('##')[1] }
            })
          }
          // v.roleId = v.roleInfos.split('##')[0]
          // v.roleName = v.roleInfos.split('##')[1]
        })
      })
    },
    edit(row) { // 弹窗--编辑
      if (row) {
        console.log(row)
        // this.userPopObj = JSON.parse(JSON.stringify(row))
        this.userPopObj.companyName = this.$route.query.companyName
        this.userPopObj.userEmail = row.userEmail
        this.userPopObj.userLoginName = row.userLoginName
        this.userPopObj.userPhone = row.userPhone
        this.userPopObj.userRealName = row.userRealName
        this.userPopObj.id = row.id
      }
      row.drmModuleArr = ['yhub', 'deviceMsg', 'deviceDis']
      var rolesArr = []
      if (row.roleInfos) {
        if (row.roleInfos.indexOf(',') > -1) { rolesArr = row.roleInfos.split(',') } else { rolesArr.push(row.roleInfos) }
        this.userPopObj.roleIds = []
        rolesArr.forEach((m, mi) => {
          this.userPopObj.roleIds.push(Number(m.split('##')[0]))
        })
      } else {
        this.userPopObj.roleIds = []
      }
      if (row.allModules) {
        this.userPopObj.drmModule = []
        JSON.parse(row.allModules).forEach(v => {
          this.drmModuleOptions.forEach((m, mi) => {
            m.children.forEach(n => {
              if (v == n.value) {
                this.userPopObj.drmModule.push([m.value, n.value])
              }
            })
          })
        })
      } else {
        this.userPopObj.drmModule = []
      }
      console.log('this.userPopObj.drmModule', this.userPopObj.drmModule)
      // v.roleId = v.roleInfos.split('##')[0]
      // v.roleName = v.roleInfos.split('##')[1]
      this.isAdd = false
      this.isShowPop = true
    },
    initRoles() {
      getRoles({ 'roleName': '' }).then(res => {
        res.resultModel.forEach(v => {
          if (v.id && v.roleName) {
            this.roleOptions.push({
              value: v.roleName,
              key: v.id
            })
          }
        })
      })
    },
    add() { // 弹窗--新增
      this.isShowPop = true
      this.userPopObj = {}
      this.userPopObj.companyName = this.$route.query.companyName
      this.userPopObj.drmModule = []
      // this.userPopObj.companyParentId = this.$route.query.id
      this.isAdd = true
    },
    roleSelect(role) {
      // console.log(role)
      this.userPopObj.roleId = role
    },
    moduleSelect(value) {
      this.drmModule = value
    },
    confirmPop(formName) { // 弹窗--提交
      var param = {
        'companyId': Base64.decode(this.$route.query.id).split('+')[0],
        'id': '',
        'notifyState': false,
        'userEmail': this.userPopObj.userEmail,
        'userLoginName': this.userPopObj.userLoginName,
        'userPassword': this.userPopObj.userPassword,
        'userPhone': this.userPopObj.userPhone,
        'userRealName': this.userPopObj.userRealName
      }
      var param1 = {
        'clientId': '',
        'companyId': Base64.decode(this.$route.query.id).split('+')[0],
        'lang': '',
        'notifyState': true,
        'phoneType': '',
        'secret': '',
        'userEmail': this.userPopObj.userEmail,
        'userIdcard': '',
        'userLoginName': this.userPopObj.userLoginName,
        'userNickName': '',
        'userPassword': this.userPopObj.userPassword,
        'userPhone': this.userPopObj.userPhone,
        'userRealName': this.userPopObj.userRealName,
        'id': this.userPopObj.id,
        'userSalt': '',
        'userSex': '',
        'userState': ''
      }
      var drmModuleArr = []
      this.userPopObj.drmModule.forEach(v => {
        drmModuleArr.push(v[1])
      })
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) { // 新增
            saveUserInfo(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowPop = false
                this.isAdd = false
                this.$message({
                  type: 'success',
                  message: this.$t('warningSet.submitted')
                })
                this.updateRole(this.userPopObj.roleIds, res.resultModel)
                this.updateModule(drmModuleArr, res.resultModel)
              } else if (res.resultCode == 201) {
                this.$message({
                  type: 'error',
                  message: this.$t('company.DuplicateAccountName')
                })
              }
            })
          } else {
            updateById(param1).then(res => {
              if (res.resultCode == 1001) {
                this.updateRole(this.userPopObj.roleIds, this.userPopObj.id)
                this.updateModule(drmModuleArr, this.userPopObj.id)
                this.isShowPop = false
                this.$message({
                  type: 'success',
                  message: this.$t('warningSet.submitted')
                })
              } else if (res.resultCode == 201) {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    updateRole(roleIds, userId) { // 更新角色
      // console.log(roleIds)
      var params = {
        'roleIdList': [],
        'userId': userId
      }
      roleIds.forEach(v => {
        params.roleIdList.push(v)
      })
      insertUserAndRoles(params).then(resp => {
        this.queryList()
      })
    },
    updateModule(drmModuleArr, id) { // 更新用户权限
      var param = {
        allModules: JSON.stringify(drmModuleArr),
        id: id
      }
      updateById(param).then(res => {
        if (res.resultCode == 1001) this.queryList()
      })
    },
    deleteOne(row) { // 删除
      this.$confirm(this.$t('company.Deletethisaccount'), '', {// 是否删除该账号？
        confirmButtonText: this.$t('button.Confirm'), // '确定'
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteById2({ 'id': row.id }).then(res => {
          if (res.resultCode == '1001') {
            this.queryList()
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
          }
        })
      }).catch(() => {})
    },
    // render 事件--表头添加按钮
    renderHeader(h, { column }) { // h即为cerateElement的简写，具体可看vue官方文档
      return h(
        'div', {
          style: 'display:flex;margin:auto;'
        },
        [
          h('span', column.label),
          h('i', {
            class: 'el-icon-key',
            style: 'font-size: 16px;margin-top: 3px;color: #a5a5a5;',
            // style: 'font-size: 20px;color: #a5a5a5;margin: 10px;margin-left: calc(50% - 20px);',
            on: {
              // mouseover: this.tableHeadMouseover,
              // mouseout: this.tableHeadMouseout
              click: this.clickTableHead
            }
          })
        ],
      )
    },
    clickTableHead() { // 是否确定开启密码编辑功能
      this.$confirm('是否确定开启密码编辑功能？', '', {// 是否确定开启解绑功能？
        confirmButtonText: this.$t('button.Confirm'), // '确定'
        cancelButtonText: this.$t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        this.isShowEditPasswordBtn = true
      }).catch(() => {})
    },
    editPassword(row) { // 修改密码弹窗--显示
      this.isShowEditPasswordPop = true
      this.editPasswordObj.userRealName = row.userRealName
      this.editPasswordObj.userLoginName = row.userLoginName
    },
    editPasswordConfirmPop(formName) { // 修改密码弹窗--提交
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.editPasswordObj.newPassward1 !== this.editPasswordObj.newPassward2) {
            this.$message({
              type: 'error',
              message: this.$t('company.mustSame')// '两次输入的密码必须相同'
            })
            return
          }
          var param = {
            'password': Base64.encode(this.editPasswordObj.newPassward1),
            'userLoginName': this.editPasswordObj.userLoginName
          }
          resetPassword(param).then(res => {
            if (res.resultCode == 1001) {
              this.$message({
                type: 'success',
                message: this.$t('warningSet.submitted')
              })
              this.isShowEditPasswordPop = false
            } else {
              this.$message({
                type: 'error',
                message: this.$t('lease.Failed')
              })
            }
          })
        }
      })
    },
    tableHeadMouseover() {
      console.log('111111')
      // this.isShowPopTable = true
    },
    tableHeadMouseout() {
      console.log('22222222')
      // this.isShowPopTable = false
    },
    change(e) {
      this.$forceUpdate()
    },
    // 筛选改变事件
    changeSearch() {
      // 去掉首尾空格
      if (this.tableObj.userLoginName) this.tableObj.userLoginName = this.tableObj.userLoginName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
#companyUser{
  #tableWarp{
    background:#fff;
    margin-top:32px;
  }
}
</style>
<style lang="scss">
#companyUser{

  .el-date-editor.el-input__inner,.el-date-editor.el-input{
    width:100%!important;
  }
  .el-select{
    width:100%!important;
  }
  #filter{
    .el-input-group {
      width: 40%;
      max-width:400px;
    }
  }
  .el-cascader--medium{
    width:100%;
  }

}
</style>
